export class OrganizationRoleGrant {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleId",
            "baseName": "roleId",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetKind",
            "baseName": "targetKind",
            "type": "OrganizationRoleGrantTargetKind",
            "format": ""
        },
        {
            "name": "targetAccountId",
            "baseName": "targetAccountId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return OrganizationRoleGrant.attributeTypeMap;
    }
    constructor() {
    }
}
